import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import { House, Briefcase, Gavel, SignOut } from '@phosphor-icons/react';

const MobileNav = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  if (!user) return null;

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: House, path: '/dashboard' },
    ...(isOwner ? [{ id: 'bids', label: 'Bids', icon: Gavel, path: '/dashboard?tab=bids' }] : []),
    { id: 'jobs', label: 'All Jobs', icon: Briefcase, path: '/jobs' },
  ];

  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-bottom-nav">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const active = location.pathname === tab.path;
        return (
          <button
            key={tab.id}
            data-testid={`mobile-nav-${tab.id}`}
            onClick={() => navigate(tab.path)}
            className="mobile-nav-item"
            style={{ color: active ? 'var(--gold)' : 'var(--text-muted)' }}
          >
            <Icon size={22} weight={active ? 'fill' : 'regular'} />
            <span>{tab.label}</span>
          </button>
        );
      })}
      <button
        data-testid="mobile-nav-logout"
        onClick={logout}
        className="mobile-nav-item"
        style={{ color: 'var(--text-muted)' }}
      >
        <SignOut size={22} />
        <span>Logout</span>
      </button>
    </nav>
  );
};

export default MobileNav;
